import http from '../../utils/http';

export default {
    /**
     * 获取用户信息
     *
     * @returns
     */
    getUserInfo() {
        return http({
            url: 'user',
            method: 'GET'
        });
    },
    /**
     * 更新用户头像
     *
     * @param {*} data
     * @returns
     */
    updateUserAvatar(data) {
        return http({
            url: 'user/UpdateUserAvatar',
            method: 'PUT',
            data
        });
    },
    /**
     * 减少次数
     *
     * @param {*} data
     * @returns
     */
    reduceUserCount(data) {
        return http({
            url: 'evaluation/ReduceCardCount',
            method: 'PUT',
            params: data,
            headers: {
                notShowError: true,
                showLoading: false
            }
        });
    },
    ping(data) {
        return http({
            url: 'user/ping',
            params: data,
            headers: {
                notShowError: true,
                showLoading: false
            }
        });
    }
};
